const USER_TYPES = {
  participant: 'participant',
  trainer: 'trainer',
  localLead: 'localLead',
  admin: 'admin'
};

export default USER_TYPES;
